module.exports = __webpack_public_path__ + "static/img/service_introduce_TH02_zh_h5.5e949b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_TH02_zh_h5.png
// module id = IRgo
// module chunks = 34